import { Button, Flex, Input } from '@optiaxiom/react';
import { IconSearch, IconXmark } from '@optimizely/axiom-icons';

import { styles } from './ToolSearchInput.css';

type ToolSearchInputProps = {
  filterText: string;
  handleFilterChange: (value: string) => void;
  onClickAddToolRegistry: () => void;
};

export function ToolSearchInput({
  filterText,
  handleFilterChange,
  onClickAddToolRegistry,
}: ToolSearchInputProps) {
  return (
    <Flex className={styles.searchInputContainer}>
      <Input
        className={styles.searchInput}
        addonBefore={<IconSearch />}
        addonAfter={filterText && <IconXmark onClick={() => handleFilterChange('')} />}
        placeholder="Enter name or description"
        value={filterText}
        onChange={e => handleFilterChange(e.target.value)}
      />
      <Button appearance="primary" size="md" onClick={onClickAddToolRegistry}>
        Add tool registry
      </Button>
    </Flex>
  );
}
